import React from 'react';
import { HelpCircle } from 'lucide-react';

export const FAQ = () => {
  const items = [
    {
      q: 'Como solicitar um orçamento?',
      a: 'Clique em "Solicitar Orçamento" ou no botão do WhatsApp e envie as informações do produto e quantidade. Se preferir, fale pelos contatos do rodapé.'
    },
    {
      q: 'Quais formas de pagamento são aceitas?',
      a: 'As formas disponíveis podem variar e serão exibidas no momento do checkout. Caso tenha dúvidas, entre em contato.'
    },
    {
      q: 'Qual o prazo de entrega?',
      a: 'O prazo depende da sua região e do método de envio. Você verá a previsão durante o checkout e poderá acompanhar pelo painel quando disponível.'
    },
    {
      q: 'Posso trocar ou devolver um produto?',
      a: 'Sim. Consulte a Política de Devolução para regras e prazos. Para iniciar o processo, entre em contato informando o número do pedido.'
    },
    {
      q: 'Preciso ter conta para comprar?',
      a: 'Em geral, sim. A conta permite acompanhar pedidos, endereços e entregas. Você pode criar conta rapidamente com e-mail e senha.'
    },
    {
      q: 'Como acompanho meu pedido?',
      a: 'Após o login, acesse "Meus Pedidos" no painel para ver o status e informações de rastreamento quando disponíveis.'
    },
  ];

  return (
    <div className="bg-slate-50 dark:bg-slate-950 min-h-screen">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 pt-24 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/10 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 bg-blue-600/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6 border border-blue-500/30">
              <HelpCircle className="w-8 h-8 text-blue-400" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">Perguntas Frequentes</h1>
            <p className="text-slate-300 text-lg max-w-xl mx-auto">
              Tire suas dúvidas sobre pedidos, entregas e suporte.
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 p-8 md:p-10 -mt-8 relative z-20">
            <div className="space-y-4">
              {items.map((item, idx) => (
                <div key={idx} className="p-5 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700 hover:border-blue-200 dark:hover:border-blue-800 transition-colors">
                  <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-2 flex items-start gap-3">
                    <span className="w-6 h-6 bg-blue-600 text-white text-xs font-bold rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      {idx + 1}
                    </span>
                    {item.q}
                  </h2>
                  <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed pl-9">{item.a}</p>
                </div>
              ))}
            </div>

            <p className="text-xs text-slate-400 dark:text-slate-500 mt-8 text-center">
              Última atualização: {new Date().toLocaleDateString('pt-BR')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
